import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog.component';
import { title } from 'process';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogRef!: MatDialogRef<any>;
  constructor(private dialog: MatDialog) {}

  open(data?: any): Observable<boolean> {
    this.dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: data?.title,
        text: data?.text,
        name: data?.name,
      },
    });

    return this.dialogRef.afterClosed();
  }

  close() {
    if (this.dialogRef) {
      this.dialog.closeAll();
    }
  }
}
